/* Hot Steppa — storefront JS
   - AJAX add-to-cart with a toast confirmation; falls back to a normal
     full-page POST to /cart if fetch fails.
   - Product page variant picker: option selects drive the hidden variant id,
     price, and sold-out state (variant data comes from a JSON script tag).
   - Cart page: quantity changes submit the cart form automatically. */
(function () {
  'use strict';

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cartpill b').forEach(function (el) {
          el.textContent = '· ' + cart.item_count;
        });
        return cart;
      });
  }

  var toastTimer;
  function toast(html) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.remove(); }, 4500);
  }

  window.HotSteppa = { refreshCartCount: refreshCartCount, toast: toast };

  // ---- AJAX add-to-cart (any form posting to /cart/add) ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    fetch(form.getAttribute('action') + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (button) button.disabled = false;
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add to cart.');
          return;
        }
        refreshCartCount();
        toast('Added to cart ✓ &nbsp;<a href="/cart">View cart</a>');
      })
      .catch(function () {
        // Network/parse failure — fall back to the normal full-page POST.
        if (button) button.disabled = false;
        form.submit();
      });
  });

  // ---- Product gallery: thumbnails swap the main image ----
  function showImage(scope, src, alt) {
    var main = scope.querySelector('[data-main-image]');
    if (!main || !src) return;
    main.src = src;
    if (alt) main.alt = alt;
    scope.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-full') === src);
    });
  }

  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var scope = thumb.closest('.prodlayout') || document;
      showImage(scope, thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'));
    });
  });

  // ---- Product page variant picker ----
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-variants]');
    var idInput = root.querySelector('[data-variant-id]');
    var selects = root.querySelectorAll('[data-option-select]');
    if (!jsonEl || !idInput || !selects.length) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var layout = root.closest('.prodlayout') || root;
    var priceEl = layout.querySelector('[data-product-price]');
    var button = root.querySelector('[data-add-button]');
    var gallery = layout;

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (variant.image && gallery) showImage(gallery, variant.image, null);
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  // ---- Cart page: auto-submit quantity changes ----
  document.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
})();
